import { CredentialMethod } from "@/constants/credentials/credential"

export const getButtonName = (method: CredentialMethod) => { 
  if (method === CredentialMethod.EDIT) {
    return 'Update Credentials'
  } else { 
    return 'Save Credentials'
  }
}
